import * as React from 'react';
export const FMSvg = React.forwardRef(function FMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      fill: '#45B2E8',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 5.08a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Zm0 7.44a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6ZM4.5 8.8a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Zm7 0a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Z',
      fill: '#F6F9FC',
    }),
  );
});
FMSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var FM = {
  category: 'flag',
  colorable: false,
  name: 'FM',
  svg: FMSvg,
};
